import * as React from 'react';
import {FileObject, FileType} from 'api/library';
import Modal, {ModalProps} from 'components/Modal';
import Button, {ButtonVariant} from 'components/Button';
import Library, {libraryConfig, LibraryMode, LibraryProps} from 'components/Library';
import {Title} from 'components/Modal';

export type FilePickerProps =
  Pick<LibraryProps,
  | 'multiple'
  | 'onSelect'
  | 'upload'
  | 'type'
  | 'tabbarProps'> &
  Pick<ModalProps, 'onBlur'>;

/**
 * The file picker modal
 * @param {FilePickerProps} props
 * @return {React.ReactElement<FilePickerProps>}
 * @constructor
 */
export default function FilePicker(
    props: FilePickerProps,
): React.ReactElement<FilePickerProps> {
  const [attached, setAttached] = React.useState<FileObject[]>([]);

  /**
   * Get the config
   * @return {Config[]}
   */
  function getConfig() {
    return libraryConfig.filter((tab) => (
      tab.type === props.type || tab.type === FileType.External
    ));
  }

  /**
   * Render modal header
   * @return {JSX.Element}
   */
  function renderHeader() {
    return (
      <Title>
        Выберите файл
      </Title>
    );
  }
  /**
   * Render modal footer
   * @return {JSX.Element}
   */
  function renderFooter() {
    /**
     * Handle click on button
     */
    function handleClick(): void {
      props.onSelect && props.onSelect(attached);
      props.onBlur && props.onBlur();
    }
    return (
      <Button
        variant={ButtonVariant.Primary}
        disabled={attached.length === 0}
        onClick={handleClick}
      >
        {`Прикрпепить (${attached.length})`}
      </Button>
    );
  }
  /**
   * Handle of selected file's
   * @param {FileObject[]} attached
   */
  function handleSelected(attached: FileObject[]) {
    attached.length > 0 && setAttached(attached);
  }
  /**
   * The handle modal blur
   */
  function handleBlur(): void {
    props.onBlur && props.onBlur();
  }
  return (
    <Modal
      fullScreen
      renderHeader={renderHeader()}
      renderFooter={renderFooter()}
      onBlur={handleBlur}
    >
      <Library
        mode={LibraryMode.Picker}
        type={props.type}
        config={getConfig()}
        multiple={props.multiple}
        upload={props.upload}
        tabbarProps={props.tabbarProps}
        onSelect={handleSelected}
      />
    </Modal>
  );
}
